/* Norvena golovure advertorial kit: reveal content, route every CTA/link to the
 * offer/bundle tiers, ONE sticky CTA that appears on scroll (hidden when the buy
 * controls are on screen so it never covers them), plus tabs/carousel fallbacks. */
(function () {
  'use strict';

  function reveal() {
    document.querySelectorAll('.gv .scroll-trigger, .gv .animate--fade-up, .gv [class*="animate--"], .gv .reveal, .gv .fade-out, .gv [class*="fade-out"], .gv .roadmap-item').forEach(function (el) {
      el.style.opacity = '1'; el.style.transform = 'none'; el.style.visibility = 'visible';
      el.classList.add('scroll-trigger--offscreen'.replace('--offscreen', ''));
    });
  }

  function offer() {
    return document.querySelector('.lumin-product-block-qty-break, [class*="quantity-break"], [class*="bundle-save"]') ||
           document.querySelector('product-form, .product-form, [id*="__main"]');
  }
  function goOffer() {
    var el = offer(); if (!el) return;
    var to = Math.max(0, window.scrollY + el.getBoundingClientRect().top - 20);
    var from = window.scrollY, d = to - from, t0 = Date.now();
    clearInterval(window.__gvTw);
    window.__gvTw = setInterval(function () {
      var k = Math.min(1, (Date.now() - t0) / 480);
      var s = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      window.scrollTo(0, Math.round(from + d * s)); if (k >= 1) clearInterval(window.__gvTw);
    }, 16);
  }
  function wireCtas() {
    document.querySelectorAll('.gv a, .gv button, .gv [role="button"], .gv [class*="btn"], .gv [class*="button"]').forEach(function (a) {
      if (a.__gv) return; a.__gv = 1;
      var h = a.getAttribute && (a.getAttribute('href') || '');
      if (/^(mailto:|tel:)/i.test(h)) return;
      if (a.closest('summary') || a.tagName === 'SUMMARY') return;
      if (a.closest('[data-component*="tab"], [class*="tab"], [class*="carousel__arrow"], [class*="slider__arrow"], [class*="accordion"]')) return;
      a.addEventListener('click', function (e) { e.preventDefault(); goOffer(); });
    });
  }

  /* content_tabs: buttons carry data-tab = the panel id. Wire clicks AND set the initial
   * state (show one panel, hide the rest) — otherwise every panel renders stacked. */
  function tabs() {
    var btns = [].slice.call(document.querySelectorAll('.gv [class*="tab-button"][data-tab]'));
    if (!btns.length) return;
    var panels = btns.map(function (b) { return document.getElementById(b.getAttribute('data-tab')); }).filter(Boolean);
    if (!panels.length) return;
    function show(id) {
      panels.forEach(function (p) { p.style.setProperty('display', p.id === id ? 'block' : 'none', 'important'); });
      btns.forEach(function (b) {
        var on = b.getAttribute('data-tab') === id;
        b.classList.toggle('is-active', on); b.classList.toggle('active', on);
      });
    }
    btns.forEach(function (b) {
      if (b.__gvt) return; b.__gvt = 1; b.style.cursor = 'pointer';
      b.addEventListener('click', function () { show(b.getAttribute('data-tab')); });
    });
    if (!document.querySelector('.gv .__gvTabInit')) {
      var active = document.querySelector('.gv [class*="tab-button"].is-active[data-tab]');
      show((active || btns[0]).getAttribute('data-tab'));
      panels[0].classList.add('__gvTabInit');
    }
  }

  /* Swiper reviews carousel: render the wrapper as a scroll-snap row + wire arrows */
  function carousels() {
    document.querySelectorAll('.gv .swiper, .gv [class*="swiper-container"], .gv [class*="reviews-container"]').forEach(function (sw) {
      if (sw.__gvs) return; sw.__gvs = 1;
      var wrap = sw.querySelector('.swiper-wrapper') || sw.querySelector('[class*="swiper-wrapper"]');
      if (!wrap) return;
      wrap.style.display = 'flex'; wrap.style.overflowX = 'auto'; wrap.style.scrollSnapType = 'x mandatory';
      wrap.style.gap = wrap.style.gap || '16px'; wrap.style.transform = 'none';
      wrap.style.scrollbarWidth = 'none';
      [].forEach.call(wrap.children, function (s) { s.style.scrollSnapAlign = 'start'; s.style.flex = '0 0 auto'; s.style.width = s.style.width || 'min(340px, 82%)'; });
      var root = sw.closest('[id*="__s0"]') || sw;
      root.querySelectorAll('[class*="swiper-button"], [class*="nav-next"], [class*="nav-prev"], [class*="carousel"][class*="arrow"]').forEach(function (a) {
        if (a.__gva) return; a.__gva = 1;
        var next = /next|right/i.test(a.className);
        a.addEventListener('click', function (e) { e.preventDefault(); wrap.scrollBy({ left: (next ? 1 : -1) * wrap.clientWidth * 0.85, behavior: 'smooth' }); });
      });
    });
  }

  var st = null, shown = null;
  function buyVisible() {
    var vh = window.innerHeight || 800;
    var sel = ['.product-form__submit', '.lumin-submit', '.shopify-payment-button', '.lumin-product-block-qty-break'];
    for (var i = 0; i < sel.length; i++) { var el = document.querySelector(sel[i]); if (el) { var r = el.getBoundingClientRect(); if (r.top < vh && r.bottom > 0) return true; } }
    return false;
  }
  function buildSticky() {
    if (document.getElementById('gv-sticky')) return;
    st = document.createElement('button'); st.id = 'gv-sticky'; st.type = 'button';
    st.textContent = 'PROFITER DE L’OFFRE';
    document.body.appendChild(st);
    st.addEventListener('click', function (e) { e.preventDefault(); goOffer(); });
  }
  /* cart drawer / notification open? (after clicking add-to-cart) — hide the sticky then */
  function cartOpen() {
    var sel = 'cart-drawer.active,.cart-drawer.active,.cart-drawer--active,.drawer.active,.drawer--active,.drawer.is-open,'
      + 'cart-notification.active,.cart-notification.active,.cart-notification--active,[class*="cart-drawer"].active,'
      + '.js-drawer-open,#CartDrawer.active,.mini-cart.active,.mini-cart--open,[class*="cart"][class*="open"]';
    if (document.querySelector(sel)) return true;
    var cn = document.querySelector('cart-notification,.cart-notification,#cart-notification');
    if (cn && cn.getAttribute('aria-hidden') === 'false') return true;
    var cd = document.querySelector('cart-drawer,#CartDrawer,.cart-drawer');
    if (cd && (cd.classList.contains('active') || cd.getAttribute('aria-hidden') === 'false')) return true;
    return document.body.classList.contains('cart-open') || document.documentElement.classList.contains('js-drawer-open') || document.body.classList.contains('drawer-open');
  }
  function checkSticky() {
    if (!st) return;
    var v = window.scrollY > 600 && !buyVisible() && !cartOpen();
    if (v === shown) return; shown = v;
    st.style.setProperty('display', v ? 'inline-flex' : 'none', 'important');
  }

  /* competitor "Save 30% / 50%" pill inline with the tier title (Shopify strips styled
   * spans from the title setting, so inject it here; Lumin re-renders tiers so keep re-running) */
  function savePills() {
    document.querySelectorAll('[class*="lumin-product-block-qty-break-title"]').forEach(function (t) {
      var txt = t.textContent || '';
      var pct = /Achetez\s*2\b/.test(txt) ? '30%' : (/Achetez\s*3\b|4e\s*OFFERT/i.test(txt) ? '50%' : '');
      if (!pct) return;
      if (t.querySelector('.gv-save')) return;
      var s = document.createElement('span');
      s.className = 'gv-save'; s.textContent = 'Économisez ' + pct;
      (t.querySelector('strong') || t).insertAdjacentElement('afterend', s);
    });
  }

  /* top announcement bar like the competitor: green, white, 3 rotating FR messages */
  function buildAnnc() {
    if (location.pathname.indexOf('/products/golovure') !== -1) return;
    if (document.getElementById('gv-annc')) return;
    var msgs = ["SOLDES D'AUTOMNE - OFFRE BIENTÔT TERMINÉE !",
                "LIVRAISON GRATUITE SUR TOUTES LES COMMANDES !",
                "GARANTIE SATISFAIT OU REMBOURSÉ 90 JOURS !"];
    var bar = document.createElement('div'); bar.id = 'gv-annc';
    var span = document.createElement('span'); span.className = 'gv-annc-msg';
    span.textContent = msgs[0]; bar.appendChild(span);
    document.body.insertBefore(bar, document.body.firstChild);
    var i = 0;
    setInterval(function () {
      span.style.opacity = '0';
      setTimeout(function () { i = (i + 1) % msgs.length; span.textContent = msgs[i]; span.style.opacity = '1'; }, 400);
    }, 3500);
  }

  function init() { buildAnnc(); reveal(); wireCtas(); tabs(); carousels(); buildSticky(); checkSticky(); savePills(); }
  if (document.readyState !== 'loading') init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 500); setTimeout(init, 1500);
  window.addEventListener('scroll', checkSticky, { passive: true });
  setInterval(checkSticky, 400);
  setInterval(savePills, 700);
  /* react instantly when the cart drawer opens after add-to-cart */
  document.addEventListener('click', function () { [60, 240, 600].forEach(function (d) { setTimeout(checkSticky, d); }); }, true);
  document.addEventListener('cart:refresh', checkSticky);
  document.addEventListener('cart:open', checkSticky);
})();
